/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum AlertDateTrigger {
  before = "before",
  at = "at",
  after = "after",
}

export const AlertDateTriggerDisplay: Record<AlertDateTrigger, string> = {
  [AlertDateTrigger.before]: "Before",
  [AlertDateTrigger.at]: "At",
  [AlertDateTrigger.after]: "After",
};
